module.exports = __webpack_public_path__ + "img/mailchimp.ec3e5e48.svg";